// src/layouts/home-hero/home-hero.tsx
import SanityImage from "@a24/ui/SanityImage";
import Video from "@a24/ui/Video";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var HomeHero = ({
  className = "",
  id,
  image,
  title = "New York's Oldest Off-Broadway Theater",
  video
}) => {
  const hasContent = title && (image || video);
  return hasContent ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { className: "h-full full-viewport-width absolute top-0 left-0 bg-hero-black" }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: `${className} full-viewport-width sticky top-0 flex items-center justify-center h-[calc(100vh-8.875rem)] lg:h-[calc(100vh-13.25rem)] bg-heritage-black-full`,
        id,
        children: [
          image && !video && /* @__PURE__ */ jsx(
            SanityImage,
            {
              className: "absolute left-0 top-0 w-full h-full",
              imageClassName: "object-cover w-full h-full",
              sanityImageSourceData: image,
              width: 1440,
              height: 795
            }
          ),
          video && /* @__PURE__ */ jsx(
            Video,
            {
              id: "home-video",
              image,
              highResSrc: video?.highRes,
              lowResSrc: video?.lowRes,
              width: 1440,
              height: 795,
              fit: "object-cover",
              className: "absolute left-0 top-0 w-full h-full will-change-[opacity]",
              buttonClassName: "transition-home-hero-opacity opacity-0 not-[body.home-ready_&]:duration-0 [body.home-scrolled_&]:duration-0 [body.home-ready_&]:opacity-100",
              gradient: /* @__PURE__ */ jsx("div", { className: "w-full h-[7.63rem] absolute bottom-0 left-0 home-video-gradient pointer-events-none" })
            }
          )
        ]
      }
    )
  ] }) : /* @__PURE__ */ jsx(Fragment, {});
};
var home_hero_default = HomeHero;

export {
  home_hero_default
};
